import { css } from '@mui/material/styles';
export const inputAdornmentComponentOverrides = {
    MuiInputAdornment: {
        styleOverrides: {
            root: ({ theme }) => css `
                /* for emphasis */
                &.MuiInputAdornment-root {
                    &.MuiInputAdornment-positionStart,
                    &.MuiInputAdornment-positionEnd,
                    &.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel),
                    &.MuiInputAdornment-positionEnd:not(.MuiInputAdornment-hiddenLabel) {
                        max-height: none;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin: unset;

                        & > .MuiIconButton-root {
                            height: 1.5rem;
                            width: 1.5rem;
                        }

                        & > .MuiSvgIcon-root, & > .MuiIconButton-root {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            fill: ${theme.tokens.FuelColorGray700};
                        }
                    }
                }
            `
        }
    }
};
